import { canAccess } from "./authorization";

// SCRUM-992: default landing page values (keys of ROLE_CAPABILITIES pages)
// and where each one routes after login.
export const LANDING_PAGE_ROUTES = {
  my_tasks: "/my-tasks",
  dashboard: "/dashboard",
  billing: "/billings",
  account_insights: "/case-manager",
  device_orders: "/device-orders",
  executive_dashboard: "/executive-dashboard",
  admin: "/admin/dashboard",
  inventory: "/inventory/dashboard",
};

// Set by applyAuthSuccess from user.default_context.landing_page and read
// once by the login page, so the default applies to that login only.
const PENDING_LANDING_PAGE_KEY = "pending_landing_page";

export const setPendingLandingPage = (page) => {
  if (page) sessionStorage.setItem(PENDING_LANDING_PAGE_KEY, page);
  else sessionStorage.removeItem(PENDING_LANDING_PAGE_KEY);
};

// Returns the route for the pending default landing page, or null when none
// is set or the user can't access it (role or my_tasks_access changed since
// it was saved), and clears it either way.
export const consumePendingLandingRoute = (user) => {
  const page = sessionStorage.getItem(PENDING_LANDING_PAGE_KEY);
  sessionStorage.removeItem(PENDING_LANDING_PAGE_KEY);
  if (!page || !LANDING_PAGE_ROUTES[page] || !canAccess(user, page)) return null;
  return LANDING_PAGE_ROUTES[page];
};
